import { useLayoutEffect } from "react";
import { Layout } from "../../components/common/Layout";
import { WaybillsTable } from "../../components/waybills/WaybillsTable";

export const WaybillsPage = () => {
    const title = "Электронные путевые листы";

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "white";
        document.body.style.backgroundImage = "";
    }, []);

    return (
        <Layout title={title}>
            <WaybillsTable />
        </Layout>
    );
};
